export enum PublicMeditationKind {
    TEXT = "text",
    AUDIO = "audio",
    TEXT_AND_AUDIO = "textAndAudio",
}

export interface PublicMeditation {
    id: string;
    title: string;
    description: string | null;
    language: string | null;
    declaredDurationSeconds: number | null;
    estimatedSeconds: number;
    kind: PublicMeditationKind;
    therapyTypes: string[];
    presentingProblems: string[];
    authorName: string | null;
    publishedAt: string | null;
}
